import { FETCH_USER_PROFILE_FAILURE, FETCH_USER_PROFILE_REQUEST, FETCH_USER_PROFILE_SUCCESS ,FETCH_PROVIDERS_PROFILES_FAILURE,FETCH_PROVIDERS_PROFILES_REQUEST,FETCH_PROVIDERS_PROFILES_SUCCESS, UPDATE_PROFILE_STATUS_REQUEST, UPDATE_PROFILE_STATUS_SUCCESS, UPDATE_PROFILE_STATUS_FAILURE, UPDATE_PROFILE_IMAGE_SUCCESS} from "./actionType";

const initialState = {
  loading: false,
  profile: null,
  error: null,
  providersProfiles:null,
  totalPages:1,
  updateLoading:false,
  updateError:null
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_USER_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        profile: action.payload,
        error: null,
      };
    case FETCH_USER_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        profile: null,
        error: action.payload,
      };
      case FETCH_PROVIDERS_PROFILES_REQUEST:
        return{
          ...state,
          loading:true,
          error:null,
          
        };
        case FETCH_PROVIDERS_PROFILES_SUCCESS:
          return {
            ...state,
            loading:false,
            providersProfiles:action.payload.profiles,
            totalPages:action.payload.totalPages,
          };
        case FETCH_PROVIDERS_PROFILES_FAILURE:
            return{
              ...state,
              loading:false,
              error:action.payload,
            }
        case UPDATE_PROFILE_STATUS_REQUEST:
          return {
            ...state,
            updateLoading:true,
            updateError:null
          }
          case UPDATE_PROFILE_STATUS_SUCCESS:
            const { profile,profileId } = action.payload;
            const updatedProfile = state.providersProfiles.map((prof)=>prof._id===profileId?profile:prof);
            return {
              ...state,
              updateLoading:false,
              providersProfiles:updatedProfile
            }
            case UPDATE_PROFILE_STATUS_FAILURE:
              return{
                  ...state,
                  updateLoading:false,
                  updateError:null,
              }
              case UPDATE_PROFILE_IMAGE_SUCCESS:
                return{
                  ...state,
                  profile:action.payload
                }
    default:
      return state;
  }
};
